import React from 'react';
import RobotPreview from './__preview/robot__preview';
import { RobotProvider } from './context';
import { RobotProps } from './robot.types';
import { RobotContent } from './__content/robot__content';
import { RobotKeyboard } from './__keyboard/robot__keyboard';

const RobotProblem = (props: RobotProps) => (
    <RobotProvider {...props}>
        <RobotContent />
        <RobotKeyboard />
    </RobotProvider>
);

// Попробовать RobotProps | RobotPropsPreview или использовать RobotPreview напрямую
// чтобы у превью были только нужные ему пропы - только problem
const Robot = (props: RobotProps) =>
    props.previewMode ? <RobotPreview problem={props.problem} /> : <RobotProblem {...props} />;

export default Robot;
